import type {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog,
} from '@common/types'
import { stringify as stringifyQs } from 'qs'
import urlJoin from 'url-join'

export const financialProviderSection = '/financial-providers/'

export enum FinancialProviderListUrlFiltersEnum {
  contactEmail = 'contactEmail',
  contactPhone = 'contactPhone',
  contactName = 'contactName',
  name = 'name',
  query = 'query',
}
export type FinancialProviderListUrlFilters = Filters<FinancialProviderListUrlFiltersEnum>
export type FinancialProviderListUrlDialog = 'add' | 'remove' | TabActionDialog
export enum FinancialProviderListUrlSortField {
  name = 'name',
  createdAt = 'createdAt',
}
export type FinancialProviderListUrlSort = Sort<FinancialProviderListUrlSortField>
export type FinancialProviderListUrlQueryParams = ActiveTab &
  BulkAction &
  Dialog<FinancialProviderListUrlDialog> &
  Pagination &
  FinancialProviderListUrlFilters &
  FinancialProviderListUrlSort

export const financialProviderListUrl = (params?: FinancialProviderListUrlQueryParams): string => {
  const FinancialProviderList = financialProviderSection
  if (params === undefined) {
    return FinancialProviderList
  } else {
    return urlJoin(FinancialProviderList, '?' + stringifyQs(params))
  }
}

export const financialProviderDetailPath = (id: string) => urlJoin(financialProviderSection, id)

export type FinancialProviderDetailUrlDialog = 'change-password' | 'remove' | 'add-contact'

export enum FinancialProviderDetailContactSortField {
  name = 'name',
  role = 'role',
}

export type FinancialProviderDetailContactSort = Sort<FinancialProviderDetailContactSortField>

export type FinancialProviderDetailUrlQueryParams = Dialog<FinancialProviderDetailUrlDialog> &
  SingleAction &
  Pagination &
  FinancialProviderDetailContactSort

export const financialProviderDetailUrl = (
  id: string,
  params?: FinancialProviderDetailUrlQueryParams,
) => financialProviderDetailPath(encodeURIComponent(id)) + '?' + stringifyQs(params)

export const financialProviderDetailUrlWithId =
  (id: string) => (params?: FinancialProviderDetailUrlQueryParams) =>
    financialProviderDetailPath(encodeURIComponent(id)) + '?' + stringifyQs(params)
